import { TimesheetEntries } from '@sit/api-types';

export const DELETE_CLUSTER_NODE_REQUEST = 'DELETE_CLUSTER_NODE_REQUEST';
export const DELETE_CLUSTER_NODE_REQUEST_FAILURE = 'DELETE_CLUSTER_NODE_REQUEST_FAILURE';
export const DELETE_CLUSTER_NODE_REQUEST_SUCCESS = 'DELETE_CLUSTER_NODE_REQUEST_SUCCESS';

export const GET_CLUSTERS_REQUEST = 'GET_CLUSTERS_REQUEST';
export const GET_CLUSTERS_REQUEST_FAILURE = 'GET_CLUSTERS_REQUEST_FAILURE';
export const GET_CLUSTERS_REQUEST_SUCCESS = 'GET_CLUSTERS_REQUEST_SUCCESS';

export const SPLIT_CLUSTER_REQUEST = 'SPLIT_CLUSTER_REQUEST';
export const SPLIT_CLUSTER_REQUEST_FAILURE = 'SPLIT_CLUSTER_REQUEST_FAILURE';
export const SPLIT_CLUSTER_REQUEST_SUCCESS = 'SPLIT_CLUSTER_REQUEST_SUCCESS';

export const SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST = 'SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST';
export const SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_FAILURE = 'SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_FAILURE';
export const SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_SUCCESS = 'SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_SUCCESS';

export const SPLIT_CLUSTER_AND_OPEN_CLUSTER_ASSIGN_MODAL_REQUEST = 'SPLIT_CLUSTER_AND_OPEN_CLUSTER_ASSIGN_MODAL_REQUEST';

export const UPDATE_CLUSTER_REQUEST = 'UPDATE_CLUSTER_REQUEST';
export const UPDATE_CLUSTER_REQUEST_FAILURE = 'UPDATE_CLUSTER_REQUEST_FAILURE';
export const UPDATE_CLUSTER_REQUEST_SUCCESS = 'UPDATE_CLUSTER_REQUEST_SUCCESS';

export const UPDATE_CLUSTER_NODE_REQUEST = 'UPDATE_CLUSTER_NODE_REQUEST';
export const UPDATE_CLUSTER_NODE_REQUEST_FAILURE = 'UPDATE_CLUSTER_NODE_REQUEST_FAILURE';
export const UPDATE_CLUSTER_NODE_REQUEST_SUCCESS = 'UPDATE_CLUSTER_NODE_REQUEST_SUCCESS';

export const UPDATE_CLUSTER_OVERLAPS_REQUEST = 'UPDATE_CLUSTER_OVERLAPS_REQUEST';
export const UPDATE_CLUSTER_OVERLAPS_REQUEST_FAILURE = 'UPDATE_CLUSTER_OVERLAPS_REQUEST_FAILURE';
export const UPDATE_CLUSTER_OVERLAPS_REQUEST_SUCCESS = 'UPDATE_CLUSTER_OVERLAPS_REQUEST_SUCCESS';

export interface SplitClusterAndAssignToEntryPayload {
  id: string;
  nodesToRemove: string[];
  existingEntry: TimesheetEntries;
  action: string;
}
